AGA.DynamicQuery = (function () {

    var saveTimeout = null;

    var clearSaveTimeout = function () {
        if (saveTimeout)
            clearTimeout(saveTimeout);
        saveTimeout = null;
    };

    var getModalConfiguration = function (configuration) {
        var defaults = {
            id: 'DynamicQueryModal',
            url: '',
            size: "large",
            displayFooter: false,
            displayTitle: false,
            // ocupar 90% da altura, menos a altura do footer do modal
            height: parseInt($(window).height() * 0.9) - 70
        };

        var result = $.extend(defaults, configuration);
        return result;
    };

    var getCurrentQueryId = function () {
        var value = AGA.Lookup.getValue("DynamicQuerySelectorMain");
        return value;
    };

    var updateFilters = function (queryId, unlockColumnsContainer) {
        AGA.Helper.blockElement("#FiltrosBody", "Carregando filtros...");
        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetFilters?queryId=" + String(queryId) + "&_=" + new Date().getTime());

        // Update filtros
        $("#FiltrosPlaceholder").load(url, function () {
            AGA.Helper.unblockElement("#FiltrosBody");
            AGA.JavascriptButton.enable("#ModificarFiltrosButton");
            AGA.JavascriptButton.enable("#LimparFiltrosButton");
            $(".btn-generation").each(function (index, item) {
                AGA.JavascriptButton.enable(item);
            });

            if (unlockColumnsContainer) {
                AGA.Helper.unblockElement("#ColumnsBody");
            }
        });
    };

    var updateColumns = function (queryId) {
        AGA.Helper.blockElement("#ColumnsBody", "Carregando colunas...");
        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetColumns?queryId=" + String(queryId) + "&_=" + new Date().getTime());

        // Update filtros
        $("#ColumnsPlaceholder").load(url, function () {
            AGA.Helper.unblockElement("#ColumnsBody");
        });
    };

    var updateCurrent = function () {
        var current = getCurrentQueryId();
        updateFilters(current);
        updateColumns(current);
        $(".dynamic-query-output").empty()
        $(".row-message-execute").show();
    };

    var selectQueryImplementation = function (queryId, queryName) {
        AGA.Lookup.setValue("DynamicQuerySelectorMain", queryId, queryName);
    };

    var getFilterData = function () {
        var queryId = getCurrentQueryId();
        if (AGA.Helper.isNullValue(queryId))
            return null;

        var valores = AGA.Form.getValues("FormFiltros");
        var names = [];
        var values = [];
        for (prop in valores) {
            if (valores.hasOwnProperty(prop)) {
                names.push(prop);
                values.push(valores[prop]);
            }
        }

        return {
            queryId: queryId,
            names: names,
            values: values
        };
    };

    var saveFilterData = function (data) {
        if (data) {
            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveUserFilterValues");
            $.ajax({
                url: url,
                method: "POST",
                data: data
            });
        }
    };

    var saveFilterValues = function () {
        var data = getFilterData();
        saveFilterData(data);
    };

    var queryChangedImplementation = function () {
        // Limpar o timeout para garantir que o filtro antigo seja salvo
        saveTimeout = null;

        updateCurrent();
    };

    var createNewImplementation = function (e) {
        var url = $(".aga-dynamic-query-selector").data("urlCreateNew");

        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(
            modalConfig,
            Benner.Widget.openModal,
            Benner.Widget.disposeModal);
    };

    var manageImplementation = function () {
        var url = $(".aga-dynamic-query-selector").data("urlManaging");

        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(modalConfig, Benner.Widget.openModal, Benner.Widget.disposeModal);
    };


    var copyImplementation = function () {
        var url = $(".aga-dynamic-query-selector").data("urlCopy");
        var currentQueryId = getCurrentQueryId();
        url = url + "&queryId=" + String(currentQueryId);
        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(modalConfig, Benner.Widget.openModal, Benner.Widget.disposeModal);
    };

    var changeFiltersImplementation = function () {

        // Salvar filtros
        clearSaveTimeout();
        saveFilterValues();

        // Abrir modal
        var url = $(".aga-dynamic-query-selector").data("urlManageFilters");
        url += "?imp=1&queryId=" + String(getCurrentQueryId());

        var modalConfig = getModalConfiguration({
            url: url,
            displayTitle: true,
            title: "Filtros da consulta"
        });

        Benner.ModalPage.show(
            modalConfig,
            Benner.Widget.openModal,
            function () {
                Benner.Widget.disposeModal();
                updateFilters(getCurrentQueryId());
            }
        );
    };

    var clearFilterValuesImplementation = function () {
        clearSaveTimeout();
        $("#FiltrosBody").find(".aga-lookup").each(function (index, item) { AGA.Lookup.clear(item); });
        $("#FiltrosBody").find(".aga-date").each(function (index, item) { AGA.Date.clear(item); });
        $("#FiltrosBody").find(".aga-number").each(function (index, item) { AGA.Number.setValue(item, ''); });
        $("#FiltrosBody").find(".aga-radio").each(function (index, item) { AGA.Radio.clear(item); });
        $("#FiltrosBody").find(".aga-text").each(function (index, item) { AGA.Text.clear(item); });
        saveFilterValues();
    };

    var sugestEndValue = function (e) {
        if ($(e.currentTarget).hasClass("aga-date") && e.name) {
            var regex = /^([A-Z_0-9]*)_DE$/;
            var matches = regex.exec(e.name);
            if (matches && matches.length > 1) {
                var target = matches[1] + "_ATE";
                var value = e.value;

                AGA.Date.setValue(target, value);
            }
        }
    };

    var anyFilterChangeImplementation = function (e) {
        sugestEndValue(e);
        clearSaveTimeout();
        var data = getFilterData();
        saveTimeout = setTimeout(function () {
            saveTimeout = null;
            saveFilterData(data);
        }, 2000);

        $(".dynamic-query-output").empty()
        $(".row-message-execute").show();
    };

    var saveColumns = function () {
        var names = [];

        $("input.dynamic-query-column-value-option:checked").each(function (index, item) {
            var name = $(item).data("name");
            if (name) {
                names.push(name);
            }
        });

        $("input.dynamic-query-column-filter-option:checked").each(function (index, item) {
            var name = $(item).data("name");
            if (name) {
                names.push(name);
            }
        });

        $("input.dynamic-query-column-totalization-option:checked").each(function (index, item) {
            var name = $(item).data("name");
            if (name) {
                names.push(name);
            }
        });

        var data = {
            queryId: getCurrentQueryId(),
            names: names
        };

        if (data) {
            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveSelectedColumns");
            $.ajax({
                url: url,
                method: "POST",
                data: data
            });
        }
    };

    var handleSelectedItemMoveUp = function (e) {
        var tdSource = $(e.currentTarget).closest("tr");
        var prev = $(tdSource).prev();
        if (prev && !$(prev).hasClass("item-selected-pattern")) {
            $(tdSource).insertBefore(prev);
        }
        saveColumns();
    };

    var handleSelectedItemMoveDown = function (e) {
        var tdSource = $(e.currentTarget).closest("tr");
        var next = $(tdSource).next();
        if (next) {
            $(tdSource).insertAfter(next);
        }
        saveColumns();
    };

    var handleItemUnselect = function (e) {
        var tdSource = $(e.currentTarget).closest("tr");
        var dataName = $(tdSource).data("name");
        $(tdSource).detach();

        $(`.dynamic-query-columns li[data-name="${dataName}"]`).removeClass("column-is-selected");

        let filterSelected = $(tdSource).find('input.dynamic-query-column-filter-option:checked').length > 0;
        if (filterSelected) {
            AGA.Helper.blockElement("#ColumnsBody", "Atualizando lista de filtros...");
            updateFilters(getCurrentQueryId(), true)
        }

        saveColumns();
    };

    var handleItemSelect = function (e) {
        var liSource = $(e.currentTarget).closest("li");//

        // Remover item
        $(liSource).addClass("column-is-selected");

        // Adicionar lista selecionados  
        var pattern = $(".item-selected-pattern").get(0);
        var item = pattern.cloneNode(true);

        $(item).data("name", liSource.data("name")).removeClass("hide item-selected-pattern");
        $(item).find('.col-group-span').append(liSource.data("table-group"))
        $(item).find('.col-title-span').append(liSource.data("title"))

        $(item).find("input.dynamic-query-column-value-option").data("name", liSource.data("name"));
        $(item).find("input.dynamic-query-column-filter-option").data("name", liSource.data("name") + "_FILTER");
        $(item).find("input.dynamic-query-column-totalization-option").data("name", liSource.data("name") + "_COUNT");

        if (liSource[0].classList.contains('col-item-totalizable')) {
            $(item).find('input.dynamic-query-column-totalization-option').addClass('totalizable');
            $(item).find('input.dynamic-query-column-totalization-option')[0].removeAttribute("disabled", "");
            $(item).find('input.dynamic-query-column-totalization-option')[0].setAttribute("enabled", "");
        }

        $(item).find('input.dynamic-query-column-value-option')[0].removeAttribute("enabled", "");
        $(item).find('input.dynamic-query-column-value-option')[0].setAttribute("disabled", "");
        $(item).find('input.dynamic-query-column-value-option')[0].setAttribute("checked", "");

        $(item).find('input.dynamic-query-column-filter-option')[0].removeAttribute("disabled", "");
        $(item).find('input.dynamic-query-column-filter-option')[0].setAttribute("enabled", "");

        $(".dynamic-query-columns-selected").append(item);

        saveColumns();
    };

    var handleFiltersSearchBar = function () {
        AGA.Grid.filter($('#GridFiltros'), $(".dynamic-query-filters-search-text").val().trim());
    };

    var getSearchObject = (value) => {
        if (value) {
            let resultObject = {
                value: value.toLowerCase(),
            };

            if (value.startsWith("*")) {
                resultObject.expression = "endsWith";
                resultObject.value = resultObject.value.substring(1);
            }

            if (value.endsWith("*")) {
                resultObject.value = resultObject.value.substring(0, resultObject.value.length - 1)
                resultObject.expression = resultObject.expression != "endsWith" ? "startsWith" : "indexOf";
            }

            return resultObject;
        }
    };

    var handleSearchBar = function () {
        var text = $(".dynamic-query-search-text").val().trim();
        var itens = $(".col-item-selectable:not(.col-item-group), .dynamic-query-column-header");

        let elementosLi = $('.col-item-selectable:not(.col-item-group, .column-is-selected)');
        for (let li of elementosLi) {
            let legendaCampo = li.dataset.title;
            let legendaGrupo = li.dataset.group;
            let legendaGrupoTabela = li.dataset.tableGroup;

            if (matchesSearch(legendaCampo, legendaGrupo, legendaGrupoTabela, text)) {
                $(li).show()
                li.classList.remove('ocultado');
            } else {
                $(li).hide()
                li.classList.add('ocultado');
            }
        }

        let elementosUl = $('.dynamic-query-column-header');
        for (let ul of elementosUl) {
            if ($(ul).find('.col-item-selectable:not(.ocultado, .col-item-group)').length > 0) {
                $(ul).show()
            } else {
                $(ul).hide()
            }
        }

        var interfaceGroups = $(".col-item-group");
        for (let group of interfaceGroups) {
            let nextElement = $(group).nextAll('.col-item-selectable').not('.ocultado').first()[0];
            if (!nextElement || nextElement.classList.contains('col-item-group')) {
                $(group).hide();
            }
            else {
                $(group).show();
            }
        }
    };

    function matchesSearch(legendaCampo, grupoCampo, grupoTabela, query) {
        if (query === '') {
            return true;
        }

        let result = false;
        let searchObject = undefined;
        if (query.indexOf('*') != -1) {
            searchObject = getSearchObject(query);
            if (searchObject) {
                if (legendaCampo) {
                    result = legendaCampo.toLowerCase()[searchObject.expression](searchObject.value);
                    if (result !== -1 && result !== false) {
                        return true
                    }
                }

                if (grupoCampo) {
                    result = grupoCampo.toLowerCase()[searchObject.expression](searchObject.value);
                    if (result !== -1 && result !== false) {
                        return true
                    }
                }

                if (grupoTabela) {
                    result = grupoTabela.toLowerCase()[searchObject.expression](searchObject.value);
                    if (result !== -1 && result !== false) {
                        return true
                    }
                }
            }
        } else if (query) {
            return legendaCampo.toLowerCase() == query || grupoCampo.toLowerCase() == query || grupoTabela.toLowerCase() == query
        }
    }

    var updateTotalizationColumns = function (e) {
        saveColumns();
    };

    var updateFilterColumns = function (e) {
        disableOptionCheckbox(e)
        saveColumns();
        AGA.Helper.blockElement("#ColumnsBody", "Atualizando lista de filtros...");
        updateFilters(getCurrentQueryId(), true)
    };

    var updateValueColumns = function (e) {
        disableOptionCheckbox(e)
        saveColumns();
    };

    var disableOptionCheckbox = function (e) {
        let tdSource = $(e.currentTarget).closest("tr");
        let valueSelected = $(tdSource).find('input.dynamic-query-column-value-option:checked').length > 0;
        let filterSelected = $(tdSource).find('input.dynamic-query-column-filter-option:checked').length > 0;

        if (valueSelected == filterSelected) {
            $(tdSource).find('input.dynamic-query-column-value-option')[0].removeAttribute("disabled", "");
            $(tdSource).find('input.dynamic-query-column-value-option')[0].setAttribute("enabled", "");

            $(tdSource).find('input.dynamic-query-column-filter-option')[0].removeAttribute("disabled", "");
            $(tdSource).find('input.dynamic-query-column-filter-option')[0].setAttribute("enabled", "");

            if ($(tdSource).find('input.dynamic-query-column-totalization-option totalizable')) {
                $(tdSource).find('input.dynamic-query-column-totalization-option')[0].removeAttribute("disabled", "");
                $(tdSource).find('input.dynamic-query-column-totalization-option')[0].setAttribute("enabled", "");
            }
        }
        else if (!valueSelected) {
            $(tdSource).find('input.dynamic-query-column-filter-option')[0].removeAttribute("enabled", "");
            $(tdSource).find('input.dynamic-query-column-filter-option')[0].setAttribute("disabled", "");

            $(tdSource).find('input.dynamic-query-column-totalization-option').prop("checked", false)
            $(tdSource).find('input.dynamic-query-column-totalization-option')[0].removeAttribute("enabled", "");
            $(tdSource).find('input.dynamic-query-column-totalization-option')[0].setAttribute("disabled", "");
        }
        else {
            $(tdSource).find('input.dynamic-query-column-value-option')[0].removeAttribute("enabled", "");
            $(tdSource).find('input.dynamic-query-column-value-option')[0].setAttribute("disabled", "");

            if ($(tdSource).find('input.dynamic-query-column-totalization-option totalizable')) {
                $(tdSource).find('input.dynamic-query-column-totalization-option')[0].removeAttribute("disabled", "");
                $(tdSource).find('input.dynamic-query-column-totalization-option')[0].setAttribute("enabled", "");
            }
        }
    }

    var handlePortletClick = function (e) {
        $(e.currentTarget).closest(".portlet-title").find(".tools > a.collapse, .tools > a.expand").click();
    };

    var generateImplementation = function (format) {
        var data = getFilterData();
        data.format = format;

        var url = AGA.Ajax.getUrlPath("DynamicQuery/Generate");
        AGA.Helper.blockUI();
        $(".row-message-execute").hide();
        $(".dynamic-query-output").empty()

        try {
            $.ajax({
                url: url,
                method: "POST",
                data: data,
                success: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                },
                fail: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                }
            });
        }
        catch{
            AGA.Helper.unblockUI();
        }
    };

    var navigateGridImplementation = function (index, count) {
        var requestData = getFilterData();
        requestData.StartIndex = index;
        requestData.Count = count;

        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetGrid");
        AGA.Helper.blockUI();

        try {
            $.ajax({
                url: url,
                method: "POST",
                data: requestData,
                success: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").html(data);
                },
                fail: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                }
            });
        }
        catch{
            AGA.Helper.unblockUI();
        }
    };

    var inited = false;
    var initImplementation = function () {
        if (inited) return;
        inited = true;

        $("body").on("click", ".dynamic-query-moveup", handleSelectedItemMoveUp);
        $("body").on("click", ".dynamic-query-movedown", handleSelectedItemMoveDown);
        $("body").on("click", ".dynamic-query-unselect", handleItemUnselect);
        $("body").on("click", ".dynamic-query-select", handleItemSelect);
        $("body").on("click", ".dynamic-query-portlet > .portlet-title > .caption", handlePortletClick);

        $("body").on("click", ".dynamic-query-column-value-option", updateValueColumns);
        $("body").on("click", ".dynamic-query-column-filter-option", updateFilterColumns);
        $("body").on("click", ".dynamic-query-column-totalization-option", updateTotalizationColumns);

        $("body").on("click", ".dynamic-query-search", handleSearchBar);
        $('body').on('keydown', '.dynamic-query-search-text', (e) => {
            if (e.which == 13) {
                handleSearchBar()
            }
        })

        $("body").on("click", ".dynamic-query-filters-search", handleFiltersSearchBar);
        $('#barraBuscaFiltros').on('keydown', (e) => {
            if (e.which == 13) {
                handleFiltersSearchBar()
            }
        })
    };

    var _events = [];
    var addEventListenerImplementation = function (eventName, callback) {
        _events.push({ eventName: eventName, callback: callback });
    };

    var dispatchEventImplementation = function (eventName, data) {
        for (var i = 0; i < _events.length; i++) {
            if (_events[i].eventName === eventName) {
                _events[i].callback(data);
            }
        }
    };

    var toggleArrowImplementation = (ulId) => {
        var ul = document.getElementById(ulId);
        ul.classList.toggle('dynamic-query-selector-collapsed');


        var ul = document.getElementById(ulId);
        var lis = ul.getElementsByTagName('li');

        for (var i = 0; i < lis.length; i++) {
            var li = lis[i];
            if (li !== event.target) {
                li.classList.toggle('collapsed');
            }
        }
    }

    return {
        init: initImplementation,
        selectQuery: selectQueryImplementation,
        queryChanged: queryChangedImplementation,
        createNew: createNewImplementation,
        manage: manageImplementation,
        copy: copyImplementation,
        changeFilters: changeFiltersImplementation,
        clearFilterValues: clearFilterValuesImplementation,
        anyFilterChange: anyFilterChangeImplementation,
        generate: generateImplementation,
        navigateGrid: navigateGridImplementation,
        addEventListener: addEventListenerImplementation,
        dispatchEvent: dispatchEventImplementation,
        toggleArrow: toggleArrowImplementation
    };
})();

$(document).ready(function () {
    AGA.DynamicQuery.init();
});